import React from "react";

const PromoSection = () => {
  return (
    <section className="gauto-promo-area">
      <div className="container">
        <div className="row">

          {/* LEFT IMAGE */}
          <div className="col-md-6">
            <div className="promo-box-left">
              <img
                src="/img/toyota-offer-2.png"
                alt="promo car"
              />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-md-6">
            <div className="promo-box-right">
              <h3>
                Partner With Shambhu Cabs & Start Earning Today!
              </h3>

              <a
                href="https://wa.me/919819399797?text=Hello%20Shambhu%20Cabs%2C%20I%20am%20interested%20in%20joining%20as%20a%20driver.%20Please%20share%20details."
                target="_blank"
                rel="noopener noreferrer"
                className="gauto-btn"
              >
                Message Us
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default PromoSection;
